import BaseModelComponent from '../../../../base/base_model_component';
import ServiceFactory from '../../../../services/service_factory';
import {TimeSpan} from "@sparkware/app-utils";

export default class GenericRealityCheckComponentModel extends BaseModelComponent {
  static CLASS = 'GenericRealityCheckComponentModel';

  init(params) {
    super.init(params);

    this._setElapsedTime(params.elapsedTime)._setSessionBalance(params.sessionBalance);
  }

  _setElapsedTime(elapsedTime) {
    this._elapsedTime = elapsedTime || TimeSpan.fromMinutes(0);

    return this;
  }

  _setSessionBalance(balance) {
    this._sessionBalance = balance || 0;

    return this;
  }

  getElapsedTime() {
    return this._elapsedTime;
  }

  getSessionBalance() {
    if (this._sessionBalance < 0) {
      return -1 * this._sessionBalance;
    }

    return this._sessionBalance;
  }

  getSessionBalanceDescription() {
    let translationKey = this._sessionBalance > 0 ? 'reality_check_session_winnings_description' : 'reality_check_session_losses_description';

    return ServiceFactory.create()
      .languageService()
      .translation(translationKey);
  }
}
